import Vue from 'vue'
import VueRouter from 'vue-router'

import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
/* CORE */
import app from './routes/app'
/* ADMIN:CORE */
import users from './routes/Admin/Core/Users'
import userTypes from './routes/Admin/Core/User_types'
import smtpConfig from './routes/Admin/Core/Configs'
/* ADMIN:DEFINES */

/* ADMIN:APP */
import about from './routes/Admin/App/About'
import brands from './routes/Admin/App/Brands'
import blogCategories from './routes/Admin/App/Blog_categories'
import blog from './routes/Admin/App/Blog'
import carousel from './routes/Admin/App/Carousel'
import components from './routes/Admin/App/Components'
import contacts from './routes/Admin/App/Contacts'
import contents from './routes/Admin/App/Contents'
import modLeads from './routes/Admin/App/Mod_leads'
import products from './routes/Admin/App/Products'
import productCategories from './routes/Admin/App/Product_categories'
import references from './routes/Admin/App/References'
import siteMenu from './routes/Admin/App/Site_menu'
import socialMedia from './routes/Admin/App/Socialmedia'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'home' } },
    ...app,
    ...users,
    ...userTypes,
    ...about,
    ...brands,
    ...blogCategories,
    ...blog,
    ...carousel,
    ...components,
    ...contacts,
    ...contents,
    ...modLeads,
    ...products,
    ...productCategories,
    ...references,
    ...siteMenu,
    ...smtpConfig,
    ...socialMedia,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
